// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const POST_DELETED_BY_ADMIN = "P\u0159\u00edsp\u011bvek smazan\u00fd autorovi";
export const POST_DELETED_BY_AUTHOR = "P\u0159\u00edsp\u011bvek smaz\u00e1n autorem";
export const POST_DELETED_BY_MODERATOR = "P\u0159\u00edsp\u011bvek smazan\u00fd moder\u00e1torkou";
